// Base prefix used for contacting the backend stream
const API = 'api';

// Prefix for the semantic object service
export const SOAAS_API = `${API}/soaas`;

// Semantic objects service health endpoint
export const SOAAS_HEALTH = `${SOAAS_API}/__health`;

// Semantic objects service SOML management endpoint
export const SOML = `${SOAAS_API}/soml`;

// Endpoint for validation of SOML schema in SOAAS
export const SOML_VALIDATE = `${SOML}/validate`;

// Semantic object service status endpoint
export const SOML_STATUS = `${SOML}/status`;

// SOML RBAC management endpoint
export const SOML_RBAC = `${SOAAS_API}/soml-rbac`;

// SOML RBAC roles endpoint
export const SOML_RBAC_ROLES = `${SOML_RBAC}/roles`;

// Semantic objects service license management endpoint
export const LICENSE = `${SOAAS_API}/license`;

// Endpoint for loading application configuration properties
export const CONFIGURATION = `${API}/configuration`;

// Ontologies upload endpoint
export const ONTOLOGIES = `${API}/ontologies`;

// Schema generation endpoint
export const SCHEMA = `${API}/schema`;

// Common download endpoint
export const DOWNLOAD = `${API}/download`;

// Download endpoint for SOML
export const DOWNLOAD_SOML = `${DOWNLOAD}/soml`;

// Security endpoint
export const SECURITY = `${API}/security`;

// Security authentication endpoint
export const SECURITY_AUTHENTICATE = `${SECURITY}/authenticate`;

// Security authentication refreshing endpoint
export const SECURITY_REFRESH = `${SECURITY}/refresh`;

// The endpoint to use for querying
export const GRAPHQL = `${API}/graphql`;

// Search service endpoint
export const SEARCH_API = `${API}/search`;

// SOML management endpoint in the search service
export const SEARCH_SOML = `${SEARCH_API}/soml`;

// Endpoint for validation of SOML against the search service
export const SEARCH_VALIDATE = `${SEARCH_API}/soml/validate`;

// Search service status endpoint
export const SEARCH_STATUS = `${SEARCH_SOML}/status`;
